import { Link, NavLink } from "react-router-dom";



import logoImg from "../image/assets/mrjoe-logo-light.svg";

export default function Footer() {
  return (
    <footer className="bg-secondary text-background section-padding">
      <div className="container-safe">
        {/* Top: brand + nav */}
        <div className="xs:gap-20 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-2">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/">
              <img src={logoImg} alt="MrJoe.pro Logo" className="h-11 w-auto" />
            </Link>

            <p className="xs:mt-4 xs:text-lg xs:leading-7 mt-3 max-w-[450px] text-xs leading-4">
              Simple, free management tools purposely designed for construction & home improvement
              pros.
            </p>
          </div>

          {/* Nav */}
          <nav className="md:justify-self-end">
            <h3 className="text-primary text-xl font-semibold">MrJoe.Pro</h3>

            <ul className="xs:mt-6 mt-3 grid grid-cols-2 gap-x-16 gap-y-[18px]">
              <li>
                <NavLink to="/pub/about_us" className="hover:text-primary leading-6">
                  About
                </NavLink>
              </li>
              <li>
                <NavLink to="/pub/faq" className="hover:text-primary leading-6">
                  FAQ
                </NavLink>
              </li>
              <li>
                <NavLink to="/pub/contact_us" className="hover:text-primary leading-6">
                  Contact Us
                </NavLink>
              </li>

              <li>
                <NavLink to="/create_company" className="hover:text-primary leading-6">
                  Try for free
                </NavLink>
              </li>

                {/** 
                 * <li>
                <a href="https://mrjoe.pro/login" target="_blank" rel="noopener noreferrer"  clsName="hover:text-primary leading-6"               >
                  Try for free
                </a>
                </li>
                */}
             
            </ul>
          </nav>
        </div>

        {/* Bottom: legal */}
        <div className="border-blue-midnight xs:mt-10 mt-4 flex flex-col justify-between gap-6 border-t pt-5 max-md:items-center sm:flex-row md:items-end">
          <div className="max-xs:order-2 text-xs leading-5">
            <p>
              © 2025 MrJoe.Pro. All rights reserved.
              <br />
              MrJoe.Pro is owned and operated by Buildmetric LLC, a company registered in the state
              of Florida.
            </p>
          </div>

          <div className="max-xs:order-1 flex shrink-0 gap-4 text-sm leading-6">
            <Link to="/pub/privacy_policy" className="hover:text-primary underline underline-offset-5">
              Privacy Policy
            </Link>
            <Link to="/pub/terms_of_use" className="hover:text-primary underline underline-offset-5">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
